import type { DossierEntity } from "./types";

export function sourceNumber(value: unknown): number | null {
  if (typeof value !== "number" && typeof value !== "string") return null;
  if (typeof value === "string" && !/^-?\d+(?:\.\d+)?$/.test(value.trim())) return null;
  const result = Number(value);
  return Number.isFinite(result) && result >= 0 ? result : null;
}
export function nutritionBasis(nutrient: DossierEntity, item: DossierEntity) {
  const raw = (id: string) => nutrient.fields[id]?.rawValue;
  const quantity = sourceNumber(raw("NutrientBasisQuantityForNutrient"));
  const unit = raw("NutrientBasisQuantityForNutrientUnit");
  const serving = sourceNumber(raw("NutrientServingSize"));
  const servingUnit = raw("NutrientUnitServingSize");
  const asSold = raw("NutrientPreparationState") === "UNPREPARED";
  const itemWeight = sourceNumber(item.fields.ItemNetWeight?.rawValue);
  const portion = serving && servingUnit === "GRM" ? serving : asSold && itemWeight ? itemWeight : null;
  const canCalculate = unit === "GRM" && quantity !== null && quantity > 0
    && raw("NutrientQuantityTypeForNutrient") === "BY_MEASURE" && portion !== null;
  return { quantity, unit, portion, factor: canCalculate ? portion / quantity! : null };
}
export const nutritionRows = [
  ["NutrientEnergyJoule", "Energy", "kJ"], ["NutrientEnergyCalories", "Energy", "kcal"],
  ["NutrientFat", "Fat", "g"], ["NutrientFatOfWhichIsSaturatedAcids", "of which saturates", "g"],
  ["NutrientCarbohydrate", "Carbohydrate", "g"], ["NutrientCarbohydrateOfWhichSugar", "of which sugars", "g"],
  ["NutrientDietaryFibre", "Fibre", "g"], ["NutrientProtein", "Protein", "g"], ["NutrientSalt", "Salt", "g"], ["NutrientSodium", "Sodium", "mg"],
] as const;
